

































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { },
})
export default class ContactsInboundForm extends Vue {
  contacts = {
    name: '',
    phone: '',
    email: '',
  };
}
